export const FALLBACK_GROUP_ATTIRE_CATEGORIES = ['Other'] as const;

const collapseWhitespace = (value: string) => value.trim().replace(/\s+/g, ' ');

export const sanitizeGroupAttireCategoryName = (value: string): string => collapseWhitespace(value);

export const normalizeGroupAttireCategoryName = (value: string): string =>
  sanitizeGroupAttireCategoryName(value).toLowerCase();

export const buildGroupAttireCategoryOptions = (
  defaultCategories?: ReadonlyArray<string> | null,
  customCategories?: ReadonlyArray<string> | null,
  linkCategories?: ReadonlyArray<string> | null,
): string[] => {
  const options: string[] = [];
  const seen = new Set<string>();

  const addOption = (value: string) => {
    const sanitized = sanitizeGroupAttireCategoryName(value);
    if (!sanitized) {
      return;
    }

    const normalized = normalizeGroupAttireCategoryName(sanitized);
    if (seen.has(normalized)) {
      return;
    }

    seen.add(normalized);
    options.push(sanitized);
  };

  defaultCategories?.forEach(addOption);
  FALLBACK_GROUP_ATTIRE_CATEGORIES.forEach(addOption);
  customCategories?.forEach(addOption);
  linkCategories?.forEach(addOption);

  return options;
};

export const resolveGroupAttireCategoryName = (
  value: string,
  options: ReadonlyArray<string>,
): string => {
  const sanitized = sanitizeGroupAttireCategoryName(value);
  if (!sanitized) {
    return '';
  }

  const normalized = normalizeGroupAttireCategoryName(sanitized);
  return options.find((option) => normalizeGroupAttireCategoryName(option) === normalized) ?? sanitized;
};
